import { adapterMap, timeSeriesAdapterMap } from './adapters';
import { getAllEnvironmentVariables } from 'bc-artifacts-client/api';
import type { MetricsAdapter, TimeSeriesMetricsAdapter } from './Metrics';
import Metrics from './Metrics';

const defaultAdapters = 'performanceMarks';
const defaultTimeSeriesAdapters = 'prom';

const getLogMetricAdapters: () => Promise<MetricsAdapter[]> = async () => {
  const env = await getAllEnvironmentVariables();
  const adapterList = env?.metricsAdapters ?? defaultAdapters;
  const adapters: MetricsAdapter[] = [];
  if (adapterList) {
    // Ensure we don't load the same adapter more than once.
    const adapterSet = new Set<string>(adapterList.split(',').map((a) => a.trim()));

    for (const adapterName of adapterSet) {
      const factory = adapterMap[adapterName];
      if (factory) {
        /**
         * We only load ada pters once, and the list of adapters should be small.
         * Some use async functions to init, so awaiting them here should be ok.
         */
        // eslint-disable-next-line no-await-in-loop
        adapters.push(await factory(env));
      }
    }
  }
  return adapters;
};

const getTimeSeriesMetricAdapters = async (): Promise<TimeSeriesMetricsAdapter[]> => {
  const env = await getAllEnvironmentVariables();
  const adapterList = env?.timeSeriesMetricAdapters ?? defaultTimeSeriesAdapters;
  const adapters: TimeSeriesMetricsAdapter[] = [];
  if (adapterList) {
    const adapterSet = new Set<string>(adapterList.split(',').map((a) => a.trim()));

    for (const adapterName of adapterSet) {
      const factory = timeSeriesAdapterMap[adapterName];
      if (factory) {
        adapters.push(factory());
      }
    }
  }
  return adapters;
};

const metrics = new Metrics(getLogMetricAdapters(), getTimeSeriesMetricAdapters());

export type * from './Metrics';
export { default as withMeasure } from './withMeasure';
export * from './withMeasure';
export * from './types';
export * from './tracing';

export { metrics, getLogMetricAdapters, getTimeSeriesMetricAdapters };
